/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { Button, Dialog, DialogTitle, DialogContent, TextField, Stack } from '@material-ui/core';

import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import {
  createExclusionRuleParent
  // eslint-disable-next-line import/no-unresolved
} from 'src/redux/slices/exclusionrules';

SaveCollectionRuleDialog.propType = {
  btnName: PropTypes.string,
  icon: PropTypes.object,
  title: PropTypes.string,
  exclusionRules: PropTypes.array,
  projectName: PropTypes.object
};

export default function SaveCollectionRuleDialog({ projectName, btnName = 'Add', icon, title = '', exclusionRules }) {
  const [open, setOpen] = useState(false);
  const [fullWidth] = useState(true);
  const [maxWidth] = useState('sm');
  const today = format(new Date(), 'ddMMyyyy-HHmmss');
  const defaultname = `FR-${projectName?.project_name}-${today}`;
  const [ruleName, setRuleName] = useState(defaultname);
  const dispatch = useDispatch();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNameChange = (e) => {
    setRuleName(e.target.value);
  };

  const handleSubmit = () => {
    if (ruleName !== null) {
      const NameObj = {
        exclusion_rule_name: ruleName,
        project: projectName?.id
      };
      dispatch(createExclusionRuleParent(NameObj, exclusionRules));
    }
    handleClose();
  };
  return (
    <>
      <Button onClick={() => handleClickOpen()} variant="outlined">
        {btnName}
      </Button>
      <Dialog open={open} maxWidth={maxWidth} onClose={handleClose} fullWidth={fullWidth}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          <Stack direction={{ xs: 'colum', md: 'column' }} spacing={{ xs: 1, md: 2 }}>
            <TextField
              label="Enter Filtering Rule Set Name"
              name="exName"
              value={ruleName}
              onChange={handleNameChange}
            />
            <Stack direction={{ xs: 'colum', md: 'row' }} spacing={{ xs: 1, md: 2 }} justifyContent="flex-end">
              <Button variant="contained" onClick={() => handleClose()}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleSubmit}>
                Save
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
}
